/* eslint-disable no-unused-vars */
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IPrice, IReportStatus, IResponseRequests } from "../types/request";
import { IBarData, ISimpleData } from "../types/misc";

const initialState: IReportStatus = {
  requests: [],
  search: [],
  loading: false,
  request: null,
  total: 0,
  last_page: 1,
  current_page: 1,
  update: false,
  bar: [],
  statuses: [],
  prices: [],
};

export const request = createSlice({
  name: "request",
  initialState,
  reducers: {
    setServiceRequests: (state, action: PayloadAction<IResponseRequests>) => {
      state.requests = action.payload.data;
      state.last_page = action.payload.last_page;
      state.current_page = action.payload.current_page;
    },
    setServiceRequest: (state, action) => {
      state.request = action.payload;
    },
    setRequestStatus: (state, action: PayloadAction<ISimpleData[]>) => {
      state.statuses = action.payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setSearch: (state, action) => {
      // state.serviceRequests = action.payload.data;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setBarGraph: (state, action: PayloadAction<IBarData[]>) => {
      state.bar = action.payload;
    },
    createRequestPrice: (state, action: PayloadAction<IPrice>) => {
      state.prices = [action.payload, ...state.prices];
      if (state.request) {
        state.request.price = [action.payload, ...(state.request.price || [])];
      }
    },
    updateRequestPrice: (state, action: PayloadAction<IPrice>) => {
      state.prices = state.prices.map((rprice) =>
        rprice.id === action.payload.id ? action.payload : rprice,
      );
      if (state.request) {
        state.request.price = (state.request.price || []).map((rprice) =>
          rprice.id === action.payload.id ? action.payload : rprice,
        );
      }
    },
    deleteRequestPrice: (state, action: PayloadAction<string>) => {
      state.prices = state.prices.filter((rprice) => rprice.id !== action.payload);
      if (state.request) {
        state.request.price = (state.request.price || []).filter(
          (rprice) => rprice.id !== action.payload,
        );
      }
    },
    setLoading: (state) => {
      state.loading = !state.loading;
    },
    setServiceRequestLoading: (state) => {
      state.loading = true;
    },
    setUpdate: (state) => {
      state.update = !state.update;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSearch,
  setLoading,
  setRequestStatus,
  setServiceRequest,
  setServiceRequestLoading,
  setUpdate,
  setTotal,
  setBarGraph,
  setServiceRequests,
  createRequestPrice,
  updateRequestPrice,
  deleteRequestPrice,
} = request.actions;

export default request.reducer;
